import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../atoms/Button/Button';
import { ContentOverlay } from '../../molecules/ContentOverlay/ContentOverlay';
import { messages } from './messages';
import { UserFeedback } from './UserFeedback';
import { ExitFeedback } from './ExitFeedback';

export const UserFeedbackButton = () => {
  const [showUserFeedback, setShowUserFeedback] = useState(false);
  const [userSkippedFeedback, setUserSkippedFeedback] = useState(false);
  const [userSubmittedFeedback, setUserSubmittedFeedback] = useState(false);
  const showFeedbackScreen = !userSkippedFeedback && !userSubmittedFeedback;

  return (
    <>
      <Button onClick={() => setShowUserFeedback(true)}>
        <FormattedMessage {...messages.initiate} />
      </Button>
      {showUserFeedback && (
        <ContentOverlay>
          {showFeedbackScreen && (
            <UserFeedback
              onBack={() => setShowUserFeedback(false)}
              onSkip={() => setUserSkippedFeedback(true)}
              onSubmit={() => setUserSubmittedFeedback(true)}
            />
          )}
          {userSkippedFeedback && <ExitFeedback showThankYouMessage={false} />}
          {userSubmittedFeedback && <ExitFeedback showThankYouMessage />}
        </ContentOverlay>
      )}
    </>
  );
};
